import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manualPaymentStep1Params: null,
  manualPaymentStep2Params: null,
  openHistoryParams: null,
  plateNumberAddParams: null,
  plateNumberHistoryParams: null,
  plateNumberEditParams: null,
  qrCodeModalParams: null,
}

// TODO add ts types to params
const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    setPlateNumberHistoryParams: (state, action) => {
      state.plateNumberHistoryParams = action.payload;
    },
    clearPlateNumberHistoryParams: (state) => {
      state.plateNumberHistoryParams = null;
    },
    setPlateNumberEditParams: (state, action) => {
      state.plateNumberEditParams = action.payload;
    },
    clearPlateNumberEditParams: (state) => {
      state.plateNumberEditParams = null;
    },
    setOpenHistoryParams: (state, action) => {
      state.openHistoryParams = action.payload;
    },
    clearOpenHistoryParams: (state) => {
      state.openHistoryParams = null;
    },
    setManualPaymentStep1Params: (state, action) => {
      state.manualPaymentStep1Params = action.payload;
    },
    clearManualPaymentStep1Params: (state) => {
      state.manualPaymentStep1Params = null;
    },
    setManualPaymentStep2Params: (state, action) => {
      state.manualPaymentStep2Params = action.payload;
    },
    clearManualPaymentStep2Params: (state) => {
      state.manualPaymentStep2Params = null;
    },
    setPlateNumberAddParams: (state, action) => {
      state.plateNumberAddParams = action.payload;
    },
    clearPlateNumberAddParams: (state) => {
      state.plateNumberAddParams = null;
    },
    setQrCodeModalParams: (state, action) => {
      state.qrCodeModalParams = action.payload;
    },
    clearQrCodeModalParams: (state) => {
      state.qrCodeModalParams = null;
    },
  },
});


export const selectShowPlateNumberHistory = (state) => !!state.modals.plateNumberHistoryParams;
export const selectPlateNumberHistoryParams = (state) => state.modals.plateNumberHistoryParams;
export const selectShowPlateNumberEdit = (state) => !!state.modals.plateNumberEditParams;
export const selectPlateNumberEditParams = (state) => state.modals.plateNumberEditParams;
export const selectShowOpenHistory = (state) => !!state.modals.openHistoryParams;
export const selectOpenHistoryParams = (state) => state.modals.openHistoryParams;
export const selectShowManualPaymentStep1 = (state) => !!state.modals.manualPaymentStep1Params;
export const selectManualPaymentStep1Params = (state) => state.modals.manualPaymentStep1Params;
export const selectShowManualPaymentStep2 = (state) => !!state.modals.manualPaymentStep2Params;
export const selectManualPaymentStep2Params = (state) => state.modals.manualPaymentStep2Params;
export const selectShowPlateNumberAdd = (state) => !!state.modals.plateNumberAddParams;
export const selectPlateNumberAddParams = (state) => state.modals.plateNumberAddParams;
export const selectShowQrCodeModal = (state) => !!state.modals.qrCodeModalParams;
export const selectQrCodeModalParams = (state) => state.modals.qrCodeModalParams;

export const { 
  
  
  setPlateNumberHistoryParams,
  clearPlateNumberHistoryParams,
  setPlateNumberEditParams,
  clearPlateNumberEditParams,
  setOpenHistoryParams,
  clearOpenHistoryParams,
  setManualPaymentStep1Params,
  clearManualPaymentStep1Params,
  setManualPaymentStep2Params,
  clearManualPaymentStep2Params,
  setPlateNumberAddParams,
  clearPlateNumberAddParams,
  setQrCodeModalParams,
  clearQrCodeModalParams,
} = modalsSlice.actions;

export default modalsSlice.reducer;